import React from 'react';
import PageSyle from '../style';
import NextBackNav from '../../../components/nextBackNav';
import RoundScreen from '../../../components/roundScreen';

export default function Page12({nextPressed, backPressed, nextSlideExzists, previousSlideExzists}) {
	let style = PageSyle();
	return (
		<div style={style.outerStyle()}>
			<RoundScreen
				title='Exercise 04 Dumbbell Flys'
				rounds={[
					[
						{
							header: 'Exercise',
							value: 'Incline Dumbbell Flyes',
						},
						{
							header: '# of sets',
							value: '1 - 2',
						},
						{
							header: 'REPS / Weight',
							value: '6 - 8 Light - Mild',
						},
						{
							header: 'MINDSET/ FOCUSES INSTRUCTIONS',
							value: 'Working Set, Full STRETCH and SQUEEZE',
						},
					],
					[
						{
							header: 'Exercise',
							value: 'Incline Dumbbell Flyes',
						},
						{
							header: '# of sets',
							value: '3',
						},
						{
							header: 'REPS / Weight',
							value: 'Mild',
						},
						{
							header: 'MINDSET/ FOCUSES INSTRUCTIONS',
							value: 'Full On Set Till Failure. “SQUEEZE”',
						},
					],
				]}
			/>
			<NextBackNav
				message='Ready to continue?'
				mt={true}
				nextPressed={nextPressed}
				backPressed={backPressed}
				nextSlideExzists={nextSlideExzists}
				previousSlideExzists={previousSlideExzists}
			/>
		</div>
	);
}
